// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"2959ca30","186":"9f243912","272":"6e285f1c","372":"c7016523","377":"4b0000d2","738":"5eb2a191","841":"4db4f343","851":"7ed8efe9","856":"d17f4a3a"}[chunkId] + ".chunk.js";
};